import React from "react";
import InfoIcon from "@mui/icons-material/Info";
import { OnOffSwitch } from "components/OnOffSwitch";
import { styled } from "@mui/material/styles";
import { MenuTooltip } from "components/DataExplorationV2/MenuTooltip";

export interface SiteAnalysisProps {
  /** Site configure analysis props */
  siteAverageEnabled: boolean;
  onChangeSiteAverageEnabled: (newValue: boolean) => void;
  siteRangeEnabled: boolean;
  onChangeSiteRangeEnabled: (newValue: boolean) => void;
}

export const SiteAnalysis = ({
  siteAverageEnabled,
  onChangeSiteAverageEnabled,
  siteRangeEnabled,
  onChangeSiteRangeEnabled
}: SiteAnalysisProps): JSX.Element => {
  return (
    <>
      <StyledInfoSubtitle>Site Analysis</StyledInfoSubtitle>
      {/* Site switches */}
      <SwitchWrapper>
        <OnOffSwitch
          label="Site Average"
          labelPlacement="start"
          value={siteAverageEnabled}
          onChange={onChangeSiteAverageEnabled}
        />
        <MenuTooltip title="Site average applied for all turbines on the site.">
          <InfoIcon fontSize="small" />
        </MenuTooltip>
      </SwitchWrapper>
      <SwitchWrapper>
        <OnOffSwitch
          label="Site Range"
          labelPlacement="start"
          value={siteRangeEnabled}
          onChange={onChangeSiteRangeEnabled}
        />
        <MenuTooltip title="Show the minimum and maximum values for the current parameter across all turbines on the site.">
          <InfoIcon fontSize="small" />
        </MenuTooltip>
      </SwitchWrapper>
    </>
  );
};

const StyledInfoSubtitle = styled("div")`
  display: flex;
  margin: ${({ theme }) => theme.spacing(1)} 0 0;
  font-size: 0.75rem;
  align-items: center;
  justify-content: space-between;
`;

const SwitchWrapper = styled("div")`
  display: flex;
  gap: 4px;
`;
